import { useEffect, useRef, useState } from "react";

import { useStickyHeader } from "./useStickyHeader";

export function useStickyState() {
  const [isSticky, setIsSticky] = useState(false);
  const sentinelRef = useRef<HTMLDivElement>(null);
  const stickyRef = useRef<HTMLDivElement>(null);
  const { headerHeight } = useStickyHeader();

  useEffect(() => {
    const sentinel = sentinelRef.current;
    if (!sentinel) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsSticky(!entry.isIntersecting);
      },
      {
        rootMargin: `-${headerHeight}px 0px 0px 0px`,
      },
    );

    observer.observe(sentinel);

    return () => observer.disconnect();
  }, [headerHeight]);

  return { isSticky, sentinelRef, stickyRef };
}
